const imageExtensions = /\.(png|jpe?g|webp|avif|gif|svg)$/i;

const productAssetContexts = {
  generalRange: require.context('../assets/GenralRange', false, /\.(png|jpe?g|webp|avif|gif|svg)$/i),
  diabetic: require.context('../assets/Diabetic', false, /\.(png|jpe?g|webp|avif|gif|svg)$/i),
  cardio: require.context('../assets/Cardiao', false, /\.(png|jpe?g|webp|avif|gif|svg)$/i),
  gastrology: require.context('../assets/Gastrology', false, /\.(png|jpe?g|webp|avif|gif|svg)$/i),
  neurology: require.context('../assets/Neurology', false, /\.(png|jpe?g|webp|avif|gif|svg)$/i),
};

const fileNameSorter = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export function formatProductName(filename = '') {
  const withoutExtension = filename.replace(imageExtensions, '');

  return withoutExtension
    .replace(/[-_]+/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getProductImages(assetFolderName) {
  const context = productAssetContexts[assetFolderName];

  if (!context) {
    return [];
  }

  return context
    .keys()
    .sort((first, second) => fileNameSorter.compare(first, second))
    .map((key) => {
      const filename = key.replace('./', '');
      const source = context(key);

      return {
        filename,
        src: source.default || source,
        alt: formatProductName(filename),
      };
    });
}
